import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://ilkpzxkwhjwvollmxurg.supabase.co/storage/v1/object/public/proyectos/HERO.jpeg')",
        }}
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-slate-900/80" />
      {/* Orange accent gradient bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-24">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/30 text-orange-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-8">
          <span className="w-1.5 h-1.5 bg-orange-500 rounded-full animate-pulse" />
          Ingeniería Industrial de Alta Precisión
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-4">
          SOLUCIONES TÉCNICAS PARA{" "}
          <span className="text-orange-500">OBRAS INDUSTRIALES</span>
        </h1>

        {/* Subtitle */}
        <p className="text-orange-400 font-semibold text-lg md:text-xl mb-6 uppercase tracking-wide">
          Obras, servicios eléctricos e ingeniería
        </p>

        {/* Body text */}
        <p className="text-slate-300 text-base md:text-lg max-w-3xl mx-auto leading-relaxed mb-10">
          Llevamos <strong className="text-white">18 años</strong> brindando soluciones integrales
          para empresas, industrias y desarrollos de gran escala, con foco en la seguridad operativa
          y la mejora continua. Nos especializamos en ejecutar proyectos con estándares técnicos
          exigentes.
        </p>

        {/* CTA */}
        <a
          href="#footer"
          className="group inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-10 py-4 rounded uppercase tracking-wide transition-all duration-200 hover:shadow-xl hover:shadow-orange-500/30 hover:-translate-y-0.5"
        >
          Empieza tu proyecto hoy
          <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </a>

      </div>
    </section>
  );
}
